export class CountryItem {
    CountryList = [
        //EMEA
        { CountryID: 'C19159', LangID: 'gb' },
        { CountryID: '687779', LangID: 'cz' },
        { CountryID: 'A29633', LangID: 'de' },
        { CountryID: '687554', LangID: 'dk' },
        { CountryID: '687530', LangID: 'es' },
        { CountryID: '687499', LangID: 'fi' },
        { CountryID: '688037', LangID: 'fr' },
        { CountryID: 'E08824', LangID: 'it' },
        { CountryID: '687616', LangID: 'no' },
        { CountryID: '687300', LangID: 'pl' },
        { CountryID: '688040', LangID: 'pt' },
        { CountryID: 'A20641', LangID: 'se' },
        { CountryID: '688368', LangID: 'tr' },
        { CountryID: 'C66879', LangID: 'lu' },
        { CountryID: '687570', LangID: 'nl' },
        //US
        { CountryID: '687PDC', LangID: 'us' },
        //APAC
        { CountryID: '687463', LangID: 'au' },
        { CountryID: '687890', LangID: 'cn' },
        { CountryID: '687854', LangID: 'in' },
        { CountryID: 'K49934', LangID: 'id' },
        { CountryID: '687365', LangID: 'jp' },
        { CountryID: '688399', LangID: 'my' },
        { CountryID: '687584', LangID: 'sg' },
        { CountryID: '687611', LangID: 'kr' },
        { CountryID: '687904', LangID: 'th' },
        { CountryID: 'E07693', LangID: 'vn' },

        { CountryID: '687912', LangID: 'tw' },
        { CountryID: '687368', LangID: 'hk' },
        //LA
        { CountryID: '687465', LangID: 'ar' },
        { CountryID: '687852', LangID: 'br' },
        { CountryID: 'A49072', LangID: 'cl' },
        { CountryID: '688955', LangID: 'co' },
        { CountryID: '688954', LangID: 'pe' },

        { CountryID: "A54675", LangID: "ae", },
        { CountryID: 'A54675', LangID: 'ae' },

        { CountryID: 'MRO-US', LangID: 'mro' },
        { CountryID: 'PS-AP', LangID: 'ps-ap' },
        { CountryID: 'PS-EC', LangID: 'ps-ec' },
        { CountryID: 'PS-LA', LangID: 'ps-la' },
        { CountryID: 'PS-NA', LangID: 'ps-na' },
        { CountryID: '687466', LangID: 'za' },
        { CountryID: '687541', LangID: 'ca' },
        { CountryID: '687848', LangID: 'mx' },
        { CountryID: 'A13868', LangID: 'ru' },

        { CountryID: '350455', LangID: 'tfs' },
        { CountryID: 'N11284', LangID: 'baldwin' }
    ]
}